<template>
    <el-form ref="form" :model="form" label-width="100px">
      <input type="hidden" v-model="form.id" />
      <el-form-item label="产品标题">
        <el-input v-model="form.pro_title"></el-input>
      </el-form-item>
      <el-form-item label="所属栏目">
        <el-select v-model="form.cate_id"  placeholder="请选择">
          <el-option
              v-for="item in cateList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="关注产品">
        <el-select v-model="form.follow_id"  placeholder="请选择">
          <el-option
              v-for="item in FollowList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="关键词">
        <el-input v-model="form.pro_key" placeholder="请输入关键词"></el-input>
      </el-form-item>
      <el-form-item label="简介">
        <el-input type="textarea" :rows="2"  v-model="form.pro_info" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="路由">
        <el-input v-model="form.pro_route" placeholder="文章链接会根据路由更改"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button @click="setRoute()">自动获取</el-button>
      </el-form-item>
      <el-form-item label="作者">
        <el-input v-model="form.pro_writer"></el-input>
      </el-form-item>
      <el-form-item label="缩略图">
        <el-upload
            class="upload-demo"
            action="/api/Upload/upload.html"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :on-success="handleAvatarSuccess"
            :file-list="form.fileList"
            list-type="picture"
            :limit=1
            name="image[]"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过2Mb
          </div>
        </el-upload>
        <el-input v-model="form.pro_img" type="hidden"></el-input>
      </el-form-item>
      <el-form-item label="轮播图">
        <el-upload
            class="upload-demo"
            action="/api/Upload/upload.html"
            :on-preview="handlePreview1"
            :on-remove="handleRemove1"
            :on-success="handleAvatarSuccess1"
            multiple
            :file-list="form.fileList1"
            list-type="picture-card"
            :limit=100
            name="image[]"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过2Mb
          </div>
        </el-upload>
        <el-input v-model="form.pro_imgs" type="hidden"></el-input>
      </el-form-item>
      <el-form-item label="主要特征">
        <el-input type="textarea" :rows="4"  v-model="form.pro_char" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="行业应用">
        <el-input type="textarea" :rows="4"  v-model="form.pro_app" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="规格详述">
        <div style="border: 1px solid #ccc;">
          <Toolbar
              style="border-bottom: 1px solid #ccc"
              :editor="editor"
              :defaultConfig="toolbarConfig"
              :mode="mode"
          />
          <Editor
              style="height: 500px; overflow-y: hidden;"
              v-model="form.pro_content"
              :defaultConfig="editorConfig"
              :mode="mode"
              @onCreated="onCreated"
          />
        </div>
      </el-form-item>
      <el-form-item label="证书批准">
        <el-upload
            class="upload-demo"
            action="/api/Upload/upload.html"
            :on-preview="handlePreview2"
            :on-remove="handleRemove2"
            :on-success="handleAvatarSuccess2"
            :file-list="form.fileList2"
            multiple
            list-type="picture"
            :limit=100
            name="image[]"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过2Mb
          </div>
        </el-upload>
        <el-input v-model="form.pro_imglist" type="hidden"></el-input>
      </el-form-item>
      <el-form-item label="产品样本">
        <el-upload
            class="upload-demo"
            action="/api/Upload/fileupload.html"
            :on-preview="handlePreview3"
            :on-remove="handleRemove3"
            :on-success="handleAvatarSuccess3"
            :file-list="form.fileList3"
            multiple
            list-type="text"
            :limit=100
            name="image[]"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传pdf,txt,doc,rar,docx,zip,xls,xlsx,ppt,pptx,mp3,mp4文件，且不超过20Mb
          </div>
        </el-upload>
        <el-input v-model="form.pro_char1" type="hidden"></el-input>
      </el-form-item>
      <el-form-item label="安装维修说明">
        <el-upload
            class="upload-demo"
            action="/api/Upload/fileupload.html"
            :on-preview="handlePreview4"
            :on-remove="handleRemove4"
            :on-success="handleAvatarSuccess4"
            :file-list="form.fileList4"
            multiple
            list-type="text"
            :limit=100
            name="image[]"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传pdf,txt,doc,rar,docx,zip,xls,xlsx,ppt,pptx,mp3,mp4文件，且不超过20Mb
          </div>
        </el-upload>
        <el-input v-model="form.pro_char2" type="hidden"></el-input>
      </el-form-item>
      <el-form-item label="图纸">
        <el-upload
            class="upload-demo"
            action="/api/Upload/fileupload.html"
            :on-preview="handlePreview5"
            :on-remove="handleRemove5"
            :on-success="handleAvatarSuccess5"
            :file-list="form.fileList5"
            multiple
            list-type="text"
            :limit=100
            name="image[]"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传pdf,txt,doc,rar,docx,zip,xls,xlsx,ppt,pptx,mp3,mp4文件，且不超过20Mb
          </div>
        </el-upload>
        <el-input v-model="form.pro_app1" type="hidden"></el-input>
      </el-form-item>
      <el-form-item label="产品技术信息">
        <el-upload
            class="upload-demo"
            action="/api/Upload/fileupload.html"
            :on-preview="handlePreview6"
            :on-remove="handleRemove6"
            :on-success="handleAvatarSuccess6"
            :file-list="form.fileList6"
            multiple
            list-type="text"
            :limit=100
            name="image[]"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传pdf,txt,doc,rar,docx,zip,xls,xlsx,ppt,pptx,mp3,mp4文件，且不超过20Mb
          </div>
        </el-upload>
        <el-input v-model="form.pro_app2" type="hidden"></el-input>
      </el-form-item>
      <el-form-item label="行业手册">
        <el-upload
            class="upload-demo"
            action="/api/Upload/fileupload.html"
            :on-preview="handlePreview7"
            :on-remove="handleRemove7"
            :on-success="handleAvatarSuccess7"
            :file-list="form.fileList7"
            multiple
            list-type="text"
            :limit=100
            name="image[]"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传pdf,txt,doc,rar,docx,zip,xls,xlsx,ppt,pptx,mp3,mp4文件，且不超过20Mb
          </div>
        </el-upload>
        <el-input v-model="form.pro_hys1" type="hidden"></el-input>
      </el-form-item>
      <el-form-item label="选型手册">
        <el-upload
            class="upload-demo"
            action="/api/Upload/fileupload.html"
            :on-preview="handlePreview8"
            :on-remove="handleRemove8"
            :on-success="handleAvatarSuccess8"
            :file-list="form.fileList8"
            multiple
            list-type="text"
            :limit=100
            name="image[]"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传pdf,txt,doc,rar,docx,zip,xls,xlsx,ppt,pptx,mp3,mp4文件，且不超过20Mb
          </div>
        </el-upload>
        <el-input v-model="form.pro_hys2" type="hidden"></el-input>
      </el-form-item>
      <el-form-item label="外部链接">
        <el-input v-model="form.islink"></el-input>
      </el-form-item>
      <el-form-item label="相关产品">
        <el-input v-model="form.pro_cid"></el-input>
      </el-form-item>
<!--      <el-form-item label="添加时间">-->
<!--        <el-date-picker-->
<!--            value-format="yyyy:MM:dd HH:mm:ss"-->
<!--            v-model="form.release_time"-->
<!--            type="date"-->
<!--            placeholder="选择日期">-->
<!--        </el-date-picker>-->
<!--      </el-form-item>-->
      <el-form-item label="发布时间">
        <el-date-picker
            v-model="form.release_time"
            type="date"
            :default-value="new Date()"
            placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="排序">
        <el-input-number v-model="form.top" :min="0" :max="100" label=""></el-input-number>
      </el-form-item>
      <el-form-item label="状态">
        <el-radio-group v-model="form.pro_status">
          <el-radio-button label="0">未审核</el-radio-button>
          <el-radio-button label="1">正常</el-radio-button>
          <el-radio-button label="2">推荐</el-radio-button>
          <el-radio-button label="3">暂停</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button @click="handleClose">取消</el-button>
      </el-form-item>
    </el-form>
</template>

<script>
import axios from "axios";
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'

export default {
  name: "getProductView",
  components: { Editor, Toolbar },
  data(){
    return{
      form: {
        id: "",
        cate_id: "",
        pro_title: "",
        pro_img: "",
        pro_writer: "",
        pro_cid: "",
        top: 0,
        release_time: '',
        pro_imglist:'',
        pro_route: "",
        pro_info:'',
        islink: '',
        pro_content: '',
        pro_imgs: '',
        follow_id: '',
        fileList:[],
        fileList1:[],
        fileList2:[],
        fileList3:[],
        fileList4:[],
        fileList5:[],
        fileList6:[],
        fileList7:[],
        fileList8:[],
        pro_char:'',
        pro_char1:'',
        pro_char2:'',
        pro_key:'',
        pro_app:'',
        pro_app1:'',
        pro_app2:'',
        pro_hys1:'',
        pro_hys2:'',
        // Contentexp:[],
        pro_status: 0
      },
      cateList: [],
      FollowList: [],
      editor: null,
      toolbarConfig: { },
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF:{
          'uploadImage' : {
            // customUpload: this.uploadImg,
            server: '/api/Upload/uploadEditor.html',
            fieldName: 'image[]',
            maxFileSize: 2 * 1024 * 1024, // 2M
            maxNumberOfFiles: 50,
            allowedFileTypes: ['image/*'],
            timeout: 5 * 1000, // 5 秒
          },
          'uploadVideo':{
            // customUpload: this.uploadImg,
            server: '/api/Upload/editorFile.html',
            withCredentials: true,
            fieldName: 'files[]',
            maxFileSize: 200 * 1024 * 1024, // 200M
            // maxNumberOfFiles: 3,
            // allowedFileTypes: ['video/*'],
            // timeout: 15 * 1000, // 5 秒
          }
        }
      },
      mode: 'default', // or 'simple'
    }
  },
  // created() {
  //   this.getCategory();
  // },
  mounted() {
    let geturl = window.location.href;
    let geturlinfo = geturl.split('?')[1];
    let getqys = new URLSearchParams('?'+geturlinfo);
    let id = getqys.get('id');
    axios.get('/api/Category/easyList.html').then((res)=>{
      this.cateList = res.data;
    });
    axios.get('/api/Follow/easyList.html').then((res)=>{
      this.FollowList = res.data;
    });
    if(id > 0){
      axios.get('/api/Product/getProduct.html?id='+id).then((res)=>{
        if(res.data.code == 200){
          this.form = res.data.data;
        }
      });
    }else{
        //this.form.release_time = Date.now();
    }

  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  },
  methods:{
    setRoute(){
      var input = this.form.pro_title;
      var sanitizedVal = input.replace(/[^\w\s-]/g, '').replace(/[\s]/g, '-').toLowerCase();
      this.form.pro_route = sanitizedVal;
    },
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    resetData(){
      this.form = this.$options.data().form;
    },
    handleClose() {
      this.resetData()
    },
    handleAvatarSuccess(res) {
      let array = Object.values(res);
      this.form.pro_img = array[0]['file_url'];
    },
    handleAvatarSuccess1(res) {
      let array = Object.values(res);
      let img = this.form.pro_imgs;
      var imglist = [];
      if(img) imglist = img.split(',');
      imglist.push(array[0]['file_url']);
      this.form.pro_imgs = imglist.join(',');
    },
    handleAvatarSuccess2(res) {
      let array = Object.values(res);
      let img = this.form.pro_imglist;
      var imglist = [];
      if(img) imglist = img.split(',');
      imglist.push(array[0]['file_url']);
      this.form.pro_imglist = imglist.join(',');
    },
    handleAvatarSuccess3(res) {
      let array = Object.values(res);
      let img = this.form.pro_char1;
      var imglist = [];
      if(img) imglist = img.split(',');
      imglist.push(array[0]['file_url']);
      this.form.pro_char1 = imglist.join(',');
    },
    handleAvatarSuccess4(res) {
      let array = Object.values(res);
      let img = this.form.pro_char2;
      var imglist = [];
      if(img) imglist = img.split(',');
      imglist.push(array[0]['file_url']);
      this.form.pro_char2 = imglist.join(',');
    },
    handleAvatarSuccess5(res) {
      let array = Object.values(res);
      let img = this.form.pro_app1;
      var imglist = [];
      if(img) imglist = img.split(',');
      imglist.push(array[0]['file_url']);
      this.form.pro_app1 = imglist.join(',');
    },
    handleAvatarSuccess6(res) {
      let array = Object.values(res);
      let img = this.form.pro_app2;
      var imglist = [];
      if(img) imglist = img.split(',');
      imglist.push(array[0]['file_url']);
      this.form.pro_app2 = imglist.join(',');
    },
    handleAvatarSuccess7(res) {
      let array = Object.values(res);
      let img = this.form.pro_hys1;
      var imglist = [];
      if(img) imglist = img.split(',');
      imglist.push(array[0]['file_url']);
      this.form.pro_hys1 = imglist.join(',');
    },
    handleAvatarSuccess8(res) {
      let array = Object.values(res);
      let img = this.form.pro_hys2;
      var imglist = [];
      if(img) imglist = img.split(',');
      imglist.push(array[0]['file_url']);
      this.form.pro_hys2 = imglist.join(',');
    },
    handleChange(value) {
      console.log(value);
    },
    expurl(url){
      url = url.split('upload/');
      return url[1];
    },

    handleRemove(file, fileList) {
      let img = this.form.pro_img;
      var imglist = img.split(',');
      var url = this.expurl(file.url);
      for(let i = 0; i < imglist.length; i++){
        if(imglist[i] == url){
          imglist.splice(i,1);
        }
      }
      this.form.pro_img = imglist.join(',');
      console.log(fileList);
    },
    handleRemove1(file, fileList) {
      let img = this.form.pro_imgs;
      var imglist = img.split(',');
      var url = this.expurl(file.url);
      for(let i = 0; i < imglist.length; i++){
        if(imglist[i] == url){
          imglist.splice(i,1);
        }
      }
      this.form.pro_imgs = imglist.join(',');
      console.log(fileList);
    },
    handleRemove2(file, fileList) {
      let img = this.form.pro_imglist;
      var imglist = img.split(',');
      var url = this.expurl(file.url);
      for(let i = 0; i < imglist.length; i++){
        if(imglist[i] == url){
          imglist.splice(i,1);
        }
      }
      this.form.pro_imglist = imglist.join(',');
      console.log(fileList);
    },
    handleRemove3(file, fileList) {
      let img = this.form.pro_char1;
      var imglist = img.split(',');
      var url = this.expurl(file.url);
      for(let i = 0; i < imglist.length; i++){
        if(imglist[i] == url){
          imglist.splice(i,1);
        }
      }
      this.form.pro_char1 = imglist.join(',');
      console.log(fileList);
    },
    handleRemove4(file, fileList) {
      let img = this.form.pro_char2;
      var imglist = img.split(',');
      var url = this.expurl(file.url);
      for(let i = 0; i < imglist.length; i++){
        if(imglist[i] == url){
          imglist.splice(i,1);
        }
      }
      this.form.pro_char2 = imglist.join(',');
      console.log(fileList);
    },
    handleRemove5(file, fileList) {
      let img = this.form.pro_app1;
      var imglist = img.split(',');
      var url = this.expurl(file.url);
      for(let i = 0; i < imglist.length; i++){
        if(imglist[i] == url){
          imglist.splice(i,1);
        }
      }
      this.form.pro_app1 = imglist.join(',');
      console.log(fileList);
    },
    handleRemove6(file, fileList) {
      let img = this.form.pro_app2;
      var imglist = img.split(',');
      var url = this.expurl(file.url);
      for(let i = 0; i < imglist.length; i++){
        if(imglist[i] == url){
          imglist.splice(i,1);
        }
      }
      this.form.pro_app2 = imglist.join(',');
      console.log(fileList);
    },
    handleRemove7(file, fileList) {
      let img = this.form.pro_hys1;
      var imglist = img.split(',');
      var url = this.expurl(file.url);
      for(let i = 0; i < imglist.length; i++){
        if(imglist[i] == url){
          imglist.splice(i,1);
        }
      }
      this.form.pro_hys1 = imglist.join(',');
      console.log(fileList);
    },
    handleRemove8(file, fileList) {
      let img = this.form.pro_hys2;
      var imglist = img.split(',');
      var url = this.expurl(file.url);
      for(let i = 0; i < imglist.length; i++){
        if(imglist[i] == url){
          imglist.splice(i,1);
        }
      }
      this.form.pro_hys2 = imglist.join(',');
      console.log(fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handlePreview1(file) {
      console.log(file);
    },
    handlePreview2(file) {
      console.log(file);
    },
    handlePreview3(file) {
      console.log(file);
    },
    handlePreview4(file) {
      console.log(file);
    },
    handlePreview5(file) {
      console.log(file);
    },
    handlePreview6(file) {
      console.log(file);
    },
    handlePreview7(file) {
      console.log(file);
    },
    handlePreview8(file) {
      console.log(file);
    },
    onSubmit() {
      axios({
        method:'post',
        url:'/api/Product/setProduct.html',
        data:this.form
      }).then((res)=>{
        if(res.data.code != 200) {
          alert(res.data.msg);
        }
        else{
          alert(res.data.msg);
          this.form.id = res.data.id;
        }
      })
    },
  }
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped>

</style>